export function gridFields() {
    return Object.freeze([{
      key: 'id',
      label: 'lbl.basic.id',
      uneditable: true,
      notInTable: true,
      sortable: true,
      form: {
        type: 'input'
      }
    },
    {
      key: 'date',
      label: 'lbl.basic.date',
      sortable: true,
      form: {
        type: 'datepicker'
      }
    },
    {
      key: 'startDate',
      label: 'lbl.basic.startTime',
      uneditable: true,
      notInTable: true,
      // default: new Date,
      filterable: true,
      form: {
        type: 'datepicker',
      }
    },
    {
      key: 'endDate',
      label: 'lbl.basic.endTime',
      uneditable: true,
      notInTable: true,
      // default: nextYear,
      filterable: true,
      form: {
        type: 'datepicker',
      }
    },
    {
      key: 'locName',
      label: 'lbl.fm.locationName',
      filterable: true,
      default: 'default',
      required: true,
      form: {
        type: 'dimSearch',
        url: process.env.VUE_APP_MASTER_API_URL + 'master-service/master/location/findAll',
        config: {
          validate: "", // 参数检查，可以是正则表达式等
          bindId: 'smeltingLocation', // 绑定的 id, (id 相同的对象会被绑定)
          bindProp: "locName", // 显示的属性的名称
          submitProp: "locName" // 提交的属性
        }
      }
    },
    {
      key: 'locId',
      label: 'lbl.formulaPlan.locationCode',
      notInTable: true,
      form: {
        type: 'dimSearch',
        url: process.env.VUE_APP_MASTER_API_URL + 'master-service/master/location/findAll',
        config: {
          validate: "", // 参数检查，可以是正则表达式等
          bindId: 'smeltingLocation', // 绑定的 id, (id 相同的对象会被绑定)
          bindProp: "id", // 显示的属性的名称
          submitProp: "id" // 提交的属性
        }
      }
    },
    {
        key: 'furnaceNumber',
        label: 'lbl.basic.furnaceName',
        filterable: true,
        sortable: true,
        default: 'default',
        required: true,
        form: {
          type: 'select',
          options: [
            {value:"default", text:"lbl.basic.select.one"},
            {value:"1", text:"opt.furnaceNumber1"},
            {value:"2", text:"opt.furnaceNumber2"},
            {value:"3", text:"opt.furnaceNumber3"},
            {value:"4", text:"opt.furnaceNumber4"},
            {value:"5", text:"opt.furnaceNumber5"},
            {value:"6", text:"opt.furnaceNumber6"}
          ]
        }
    },
    {
        key: 'furnaceTime',
        label: 'lbl.basic.furnaceBatch',
        uneditable: true,
        sortable: true,
        form: {
          type: 'input'
        }
    },
    {
        key: 'drillNumber',
        label: 'lbl.sip.drillNumber',
        sortable: true,
        required: true,
        form: {
          type: 'input'
        }
    },
    {
        key: 'startTime',
        label: 'lbl.sip.startTime',
        sortable: true,
        form: {
          type: 'timepicker'
        }
    },
    {
        key: 'endTime',
        label: 'lbl.basic.endTime',
        sortable: true,
        form: {
          type: 'timepicker'
        }
    },
    {
        key: 'depth',
        label: 'lbl.sip.depth',
        sortable: true,
        required: true,
        form: {
          type: 'input'
        }
    },
    {
        key: 'mudName',
        label: 'lbl.sip.mudName',
        sortable: true,
        form: {
          type: 'input'
        }
    },
    {
        key: 'mudNumber',
        label: 'lbl.sip.mudNumber',
        sortable: true,
        form: {
          type: 'input'
        }
    },
    {
        key: 'drillTubeNumber',
        label: 'lbl.sip.drillTubeNumber',
        sortable: true,
        form: {
          type: 'input'
        }
    },
    {
        key: 'otherTubeNumber',
        label: 'lbl.sip.otherTubeNumber',
        sortable: true,
        form: {
          type: 'input'
        }
    },
    {
        key: 'slagState',
        label: 'lbl.sip.slagState',
        sortable: true,
        form: {
          type: 'input'
        }
    },
    {
        key: 'remark',
        label: 'lbl.sip.remark',
        sortable: true,
        form: {
          type: 'input'
        }
    }
    ]);
  }
  
  // class
  export const DrillDepth = function () {
    gridFields().forEach(item => {
      this[item.key] = item.default || '';
    })
  }
  
  
  export const filter = gridFields()
    .filter(v => v.filterable)
    .reduce((tar, v) => {
      tar[`${v.key}Filter`] = v.default || '';
      return tar
    }, {})
  export const filterFields = gridFields().filter(v => v.filterable).map(v => `filter.${v.key}`)